import React from 'react';
import Card from './partials/card';
import Layout from '../layouts/two';
import Title from '../partials/title';
import moment from 'moment';
import Explanation from './partials/explanation';
import _ from 'lodash';

class Rankings extends React.Component {

    state = {
        tab: this.props.partial ? 1 : 3,
        popup: false,
        selectedRanking: {},
        ageGroups: { boys: [], girls: [], base: [] },
        tss: [],
        selectedTournamentSeason: null
    }

    // Lifecycle
    componentWillMount() {
        const { gender } = this.props.params, { partial = false, ageGroups } = this.props;
        let tab = partial ? 1 : 3;
        switch (gender) {
            case 'b': tab = 1; break;
            case 'g': tab = 2; break;
            default: break;
        }
        this.setState({ tab });

        this.props.ageGroupActions.fetchTournamentSeasons();
        if (!ageGroups)
            this.props.ageGroupActions && this.props.ageGroupActions.fetch();
        else this.setState({ ageGroups });
    }
    componentWillReceiveProps = nextProps => {
        const { ageGroups, tournamentSeasons } = nextProps;
        const tss = [];
        tournamentSeasons && tournamentSeasons.forEach(ts => {
            tss.push({
                IdTournamentSeason: ts.IdTournamentSeason,
                Start: moment(ts.DateStart).utc(),
                End: moment(ts.DateEnd).utc(),
                Title: `${moment(ts.DateStart).utc().format('YYYY')} - ${moment(ts.DateEnd).utc().format('YYYY')} Road to Nationals`
            });
        });        

        const selectedTournamentSeason = this.state.selectedTournamentSeason !== null ? this.state.selectedTournamentSeason : _.findIndex(tss, ts => moment().isBetween(ts.Start, ts.End));
        this.setState({ ageGroups, tss, selectedTournamentSeason: selectedTournamentSeason !== -1 ? selectedTournamentSeason : tss.length - 1 });
    }
    //

    onTab = (tab) => this.setState({ tab, selectedRanking: null, popup: false });
    onRecComp = compOrRec => this.setState({ compOrRec });
    onPopup = ({ base, gender, types }) => {
        const { popup } = this.state;
        if (popup) {
            this.setState({ popup: false });
        } else {
            this.setState({
                popup: true,
                types,
                compOrRec: 0,
                selectedRanking: {
                    teams: types[0].teams,
                    base,
                    gender,
                    types,
                }
            });
        }
    };

    onScrollTS = direction => {
        let { selectedTournamentSeason, tss } = this.state;
        switch (direction) {
            case 0:
                if (selectedTournamentSeason === 0) selectedTournamentSeason = tss.length - 1;
                else selectedTournamentSeason--;
                break;
            case 1:
                if (selectedTournamentSeason === (tss.length - 1)) selectedTournamentSeason = 0;
                else selectedTournamentSeason++;
                break;
            default: break;
        }
        let ag = this.state.ageGroups;
        this.setState({ selectedTournamentSeason, selectedRanking: null, popup: false, ageGroups: null }, () => {
            this.setState({ ageGroups: ag });
        });

    }

    renderSection = () => {
        const { tab, popup, selectedRanking, ageGroups, compOrRec = 0, tss, selectedTournamentSeason } = this.state;
        
        return (
            <div style={{ minHeight: 400 }}>

                {/* Tabs */}
                <div className="w3-white" ref={this.top}>

                    <div className="w3-black d-flex flex-row">
                        <div onClick={() => this.onTab(1)} className="w-100 w3-black heroish-text anton p-4" style={{ borderBottom: `3px solid ${tab === 1 ? 'red' : 'white'}` }}>BOYS</div>
                        <div onClick={() => this.onTab(2)} className="w-100 w3-black heroish-text anton p-4" style={{ borderBottom: `3px solid ${tab === 2 ? 'red' : 'white'}` }}>GIRLS</div>
                    </div>

                    {tab !== 3 && !(selectedRanking && popup) && <div className="w3-container w3-content margin-top d-flex flex-column">
                        <div style={{ height: 50 }} />
                        <div className="d-flex flex-row">
                            {tss.length > 1 && <i onClick={() => this.onScrollTS(0)} className="pointer clickable fa fa-arrow-left black align-self-center mr-4" />}
                            <Title text={`${(tss[selectedTournamentSeason || 0] || {}).Title}`} />
                            {tss.length > 1 && <i onClick={() => this.onScrollTS(1)} className="pointer clickable fa fa-arrow-right black align-self-center ml-4" />}
                        </div>
                    </div>}

                    {selectedRanking && popup && <div>
                        <div className="w3-container w3-content margin-top padding-top">
                            <div className="block d-flex flex-row">
                                <div className="block d-flex flex-row align-self-center margin-top margin-bottom" onClick={this.onPopup}>
                                    <i className="far fa-arrow-alt-circle-left margin-right-half align-self-center font-40 red" />
                                    <span className=" align-self-center font-40 hind line1">Back</span>
                                </div>
                                {selectedRanking.types.length > 1 && <div className="ml-auto align-self-center">
                                    <span className={`margin-right-half inner-nav hind line1 pointer hoverable toUpper font-18 ${compOrRec === 0 ? 'selected' : ''}`} onClick={() => this.onRecComp(0)}>{'1st DIV' /*selectedRanking.types[0].Type*/}</span>
                                    {'|'}
                                    <span className={`margin-left-half inner-nav hind line1 pointer hoverable toUpper font-18 ${compOrRec === 1 ? 'selected' : ''}`} onClick={() => this.onRecComp(1)}>{'2nd DIV' /*selectedRanking.types[1].Type*/}</span>
                                </div>}
                            </div>
                            <div className="w3-animate-zoom w3-center margin-top">
                                <h1 className="anton toUpper">
                                    {selectedRanking.base.TournamentRankAgeGroup}
                                    {' '}
                                    {selectedRanking.gender.Gender}
                                    {' '}
                                    {(selectedRanking.types[compOrRec]).Type}</h1>
                                <div className="w3-responsive w3-card-4">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr className="w3-black">
                                                <th className="text-left">Team</th>
                                                <th>Points</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedRanking.types[compOrRec].teams && selectedRanking.types[compOrRec].teams.map((team, i) => (
                                                <tr key={i}>
                                                    <td className="text-left"><span className="roboto-mono font-10">{team.StandingOrdinal}</span> - {team.TeamName}</td>
                                                    <td>{team.TotalPoints}</td>
                                                </tr>))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ height: 100 }} />
                        </div>
                    </div>}

                    {tab === 1 && !popup && selectedTournamentSeason && tss[selectedTournamentSeason] && <div className="w3-container w3-content w3-animate-opacity pt-8 pb-8">

                        <div className={`w3-row-padding w3-center  ${popup ? 'hidden hide' : 'w3-margin-top'}`}>
                            {ageGroups && ageGroups.base && ageGroups.base.map((base, i) => <Card onPopup={this.onPopup} key={i} base={base}
                                group={ageGroups.boys} index={i} idTournamentSeason={tss[selectedTournamentSeason].IdTournamentSeason} />)}
                        </div>

                    </div>}

                    {tab === 2 && !popup && <div className="w3-container w3-content w3-animate-opacity pt-8 pb-8">
                        <div className="w3-row-padding w3-center w3-margin-top" style={{ minHeight: 500 }}>
                            {ageGroups && ageGroups.base && ageGroups.base.map((base, i) => <Card key={i} onPopup={this.onPopup} base={base} group={ageGroups.girls} index={i} idTournamentSeason={tss[selectedTournamentSeason].IdTournamentSeason} />)}

                        </div>
                    </div>}

                    {tab === 3 && <Explanation />}
                </div>
                {tab !== 3 && <div className="w3-red">
                    <div className="w3-container w3-content d-flex row-column pb-8 pt-8">
                        <div>
                            <Title text="What's New" className="white" />
                            <span className="white">You've asked and we've listened. Challenge Sports is excited to introduce its NEW Ranking System</span>
                        </div>
                        <div style={{ width: 30, height: 10 }} />
                        <a onClick={() => this.onTab(3)} className="p-2 bg-red white  align-self-center" style={{ borderRadius: 4, border: '1px solid #e5e5e5' }}>I WANT TO KNOW MORE</a>
                    </div>
                </div>}
            </div>
        )
    }

    render() {
        const { partial = false } = this.props;
        if (partial) return this.renderSection();
        else return (<Layout nbs="rankings" title="RANKINGS" bi="/images/backgrounds/rankings.jpg">
            {this.renderSection()}
        </Layout>)
    }

    top = React.createRef();
}

export default Rankings;



// WEBPACK FOOTER //
// ./src/components/rankings/index.js